module.exports = __webpack_public_path__ + "img/logo-cjk.9f20ee49.svg";